(function () {
  'use strict';
  function init() {
    const rows = document.querySelectorAll('[data-feat-row]');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      rows.forEach((row) => row.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    rows.forEach((row) => observer.observe(row));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
